import licenseModule from '../../license.module';
import template from './licenseUsageDetailDevice.component.html';
import style from './licenseUsageDetailDevice.component.css';

export default licenseModule.component('licenseUsageDetailDevice', {
    template,
    style,
    controller: [
        'alertLevelConstants',
        'doughnutColorConstants',
        licenseUsageDetailDeviceComponent
    ],
    bindToController: true,
    bindings: {
        deviceUsage: '<'
    }
});

function licenseUsageDetailDeviceComponent(
    alertLevelConstants,
    doughnutColorConstants
) {
    var vm = this;
    vm.$onChanges = render;
    vm.options = {
        showIcon: true
    };

    vm.size = 50;
    vm.value = 10;
    vm.total = 0;
    vm.used = 0;
    vm.remaining = 0;

    function render(changeObj) {
        if (
            changeObj.deviceUsage.currentValue &&
            changeObj.deviceUsage.currentValue != null
        ) {
            initializeValues();
            vm.total =
                vm.deviceUsage.subscription.total > 0
                    ? vm.deviceUsage.subscription.total
                    : vm.deviceUsage.perpetual.total;
            vm.used =
                vm.deviceUsage.subscription.usage > 0
                    ? vm.deviceUsage.subscription.usage
                    : vm.deviceUsage.perpetual.usage;

            vm.actualUsed = vm.deviceUsage.usage;

            vm.remaining = vm.total - vm.used < 0 ? 0 : vm.total - vm.used;

            vm.showStaticUsage = vm.deviceUsage.showStaticAllocation;

            vm.percentage = parseFloat((vm.used / vm.total) * 100);

            setProgressBar();
        }
    }

    function initializeValues() {
        if (vm.deviceUsage.subscription.total == undefined) {
            vm.deviceUsage.subscription.total = 0;
        }
        if (vm.deviceUsage.perpetual.total == undefined) {
            vm.deviceUsage.perpetual.total = 0;
        }
        if (vm.deviceUsage.subscription.usage == undefined) {
            vm.deviceUsage.subscription.usage = 0;
        }
        if (vm.deviceUsage.perpetual.usage == undefined) {
            vm.deviceUsage.perpetual.usage = 0;
        }
        if (vm.deviceUsage.usage == undefined) {
            vm.deviceUsage.usage = 0;
        }
    }

    function setProgressBar() {
        if (!vm.deviceUsage.legacy) {
            if (vm.percentage >= 100) {
                vm.progressType = alertLevelConstants.critical.toLowerCase();
                vm.percentageColor = doughnutColorConstants.red;
            } else if (vm.percentage >= 75) {
                vm.progressType = alertLevelConstants.warning.toLowerCase();
                vm.percentageColor = doughnutColorConstants.yellow;
            } else {
                vm.progressType = alertLevelConstants.none.toLowerCase();
                vm.percentageColor = doughnutColorConstants.blue;
            }
        } else {
            vm.progressType = 'grey';
            vm.percentageColor = doughnutColorConstants.grey;
        }

        vm.percentage =
            vm.percentage > 100 ? '>100' : parseInt(vm.percentage, 10);
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-usage-detail-device/licenseUsageDetailDevice.component.js